/**
 * author : RyanLiu yanfang.liu@asiainnovations.com
 * date   : 29 Nov 2018 Thu
 * desc   : Vip充值相关服务
 **/
import PbAjax from '../../lib/pbajax';
import publicpb from '../../base/public.pb';

let pbajax = new PbAjax();

class VipSvc {
    getMappingApiBase() {
        const maps = {
            pro: 'https://liveapi.upliveapps.com',
            dev: 'http://sg-liveapi.xingyunzhi.cn',
            stage: 'http://sg-liveapi.xingyunzhi.cn'
        };

        let env;

        const reg = new RegExp("(^|&)env=([^&]*)(&|$)", "i");
        env = location.search.substr(1).match(reg);
        
        if (env) {
            env = decodeURIComponent(env[2]);
        } else {
            env = 'pro';
        }

        return maps[env];
    }

    fetchRechargeOptions(countryCode) {
        let defer = $.Deferred();

        // 16是充值档位信息
        $.ajax({
            url: this.getMappingApiBase() + `/config/get?type=16&countryCode=${countryCode}`,
            method: 'GET',
            success: function(ret) {
                try {
                    const res = JSON.parse(ret);
                    defer.resolve(res.data);
                } catch(e) {
                    defer.reject(e);
                }
            },
            error: function(err) {
                defer.reject(err);
            }
        });
        return defer.promise();
    }

    fetchVipConfs(countryCode) {
        let defer = $.Deferred();

        // 21是客服
        $.ajax({
            url: this.getMappingApiBase() + `/config/get?type=21&countryCode=${countryCode}`,
            method: 'GET',
            success: function(ret) {
                try {
                    const res = JSON.parse(ret);
                    defer.resolve(res.data);
                } catch(e) {
                    defer.reject(e);
                }
            },
            error: function(err) {
                defer.reject(err);
            }
        });

        return defer.promise();
    }
}

export default new VipSvc();


// WEBPACK FOOTER //
// ./js/mall/recharge/vip.svc.js